import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PRICING, FOUNDING } from "@/lib/content";
import { Reveal } from "./Primitives";
import { Mist } from "./Mist";

const SUMMARY = ["Laboratory water testing", "Seven-day air monitoring", "Written findings + results review"];

const Offer = () => (
  <div className="mt-8 rule pt-5 max-w-md" data-testid="hero-offer">
    <p className="text-sm sm:text-[15px] text-ink">
      <span className="font-semibold">Home Hyper Assessment</span>
      <br className="sm:hidden" />
      <span className="hidden sm:inline"> </span>
      <span className="text-sec line-through decoration-[1px] decoration-sec/60" data-testid="hero-future-price">${PRICING.future.toLocaleString()}</span>{" "}
      <span className="font-semibold text-forest text-xl sm:text-[17px]" data-testid="hero-founding-price">${PRICING.base.toLocaleString()}</span>{" "}
      <span className="text-sec">Founding NYC Rate</span>
      <br className="sm:hidden" />
      <span className="hidden sm:inline text-sec"> · </span>
      <span className="text-sec">Reserve with a ${PRICING.deposit} deposit</span>
    </p>
    <p className="mt-2.5 text-[11px] tracking-[0.14em] uppercase text-sec" data-testid="hero-founding-access">
      Founding NYC Access · {FOUNDING.total - FOUNDING.claimed} of {FOUNDING.total} remaining
    </p>
    <div className="mt-1.5 h-px w-full max-w-[240px] bg-divider" role="progressbar" aria-label="Founding spots claimed" aria-valuemin={0} aria-valuemax={FOUNDING.total} aria-valuenow={FOUNDING.claimed} data-testid="hero-founding-progress">
      <div className="h-full bg-forest" style={{ width: `${(FOUNDING.claimed / FOUNDING.total) * 100}%` }} />
    </div>
    <p className="mt-2.5 text-sm text-sec">Lab fees included.</p>
    <Link to="/book" className="btn-primary mt-5 sm:hidden" data-testid="hero-offer-cta">
      Reserve your assessment — ${PRICING.deposit} <ArrowRight size={18} />
    </Link>
  </div>
);

export const Hero = ({ ctaRef }) => (
  <section className="relative bg-white" data-testid="hero-section">
    <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-14 items-center pt-8 pb-12 sm:pt-16 sm:pb-20 lg:py-24">
      <div className="lg:col-span-6 min-w-0">
        <Reveal><p className="eyebrow mb-5 sm:mb-6" data-testid="hero-eyebrow">In-home air + water testing · Upper East Side</p></Reveal>
        <Reveal delay={0.05}>
          <h1 className="h-display text-balance" data-testid="hero-headline">
            Know what’s in your home’s<br className="hidden sm:block" /> <em className="not-italic text-forest">air</em> and <em className="not-italic text-forest">water</em>.
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="lead mt-5 sm:mt-7 max-w-xl" data-testid="hero-supporting">
            We test your home’s air and water, explain what we find, and help you decide what to do next.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
            <Link to="/book" ref={ctaRef} className="btn-primary sm:px-8" data-testid="hero-book-cta">
              Book your assessment <ArrowRight size={18} />
            </Link>
            <a href="#what-we-test" className="btn-secondary border-transparent sm:border-sec/60 !min-h-[48px] text-forest" data-testid="hero-secondary-link">See what we test</a>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 sm:mt-8 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-sm sm:text-[15px] font-medium text-ink" data-testid="hero-inclusions">
            {SUMMARY.map((t, i) => (
              <span key={t} className="inline-flex items-center gap-3">
                {i > 0 && <span className="text-sec" aria-hidden>/</span>}
                {t}
              </span>
            ))}
          </p>
        </Reveal>
        <Reveal delay={0.25}><Offer /></Reveal>
      </div>
      <div className="lg:col-span-6 lg:pl-6 min-w-0">
        <Reveal delay={0.2}><Mist /></Reveal>
      </div>
    </div>
  </section>
);
